import React from "react";
import { useTranslation } from "react-i18next";

const RADIUS = 22;          // SVG ring radius inside the 52-px bubble
const CIRC = 2 * Math.PI * RADIUS;

export default function Bubble({ visible, aggregate, onExpand }) {
	const { t } = useTranslation();
	// Warnings (partial failures) light the badge too — but amber, not red:
	// the cards and the modal say "most of it worked" and the bubble must not
	// contradict them. Red only wins when something failed outright.
	const errors = aggregate.errors || 0;
	const warnings = aggregate.warnings || 0;
	const badgeModifier = errors > 0
		? "pn-bubble__badge--error"
		: warnings > 0
			? "pn-bubble__badge--warning"
			: "";
	const total = aggregate.total || 0;
	const percent = Math.max(0, Math.min(100, aggregate.percent || 0));
	const dashOffset = CIRC * (1 - percent / 100);

	const onKey = (e) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			onExpand();
		}
	};

	return (
		<button
			type="button"
			className="pn-bubble"
			data-hidden={!visible}
			aria-hidden={!visible}
			aria-label={t("progressNotifications.expand", "Re-open background tasks")}
			onClick={onExpand}
			onKeyDown={onKey}
			data-testid="progress-stack-bubble"
			tabIndex={visible ? 0 : -1}
		>
			<svg
				className="pn-bubble__ring"
				width="44"
				height="44"
				viewBox="0 0 48 48"
				aria-hidden="true"
			>
				<circle
					cx="24"
					cy="24"
					r={RADIUS}
					fill="none"
					stroke="#e4e7eb"
					strokeWidth="3"
				/>
				<circle
					cx="24"
					cy="24"
					r={RADIUS}
					fill="none"
					stroke="#7c3aed"
					strokeWidth="3"
					strokeDasharray={CIRC}
					strokeDashoffset={dashOffset}
					strokeLinecap="round"
					style={{ transition: "stroke-dashoffset 400ms cubic-bezier(.2,.7,.2,1)" }}
				/>
			</svg>
			<span className="pn-bubble__core" aria-hidden="true">
				<i className="fas fa-spinner" />
			</span>
			{total > 0 && (
				<span
					className={`pn-bubble__badge ${badgeModifier}`}
				>
					{total}
				</span>
			)}
		</button>
	);
}
